import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, NgForm, FormGroup, Validators } from '@angular/forms';
import { Observable, BehaviorSubject, EMPTY } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GeneralparametersService } from '../../shared/services/generalparameters.service';

import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { CustomerService } from '../../shared/services/customer.service';
import { Customer } from '../../shared/models/customer.model';
import { BnplService } from '../../shared/services/bnpl.service';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import { BasicData } from 'src/app/feature/BNPL/shared/models/basicdata.model';
import { ActivityContractor } from '../../shared/models/general-parameters-response.model';
import { FirstStep } from '../../shared/models/first-step.model';
import Swal from 'sweetalert2';
import { FormComponent } from 'src/app/core/components/form/form.component';
import { RespError } from '../../shared/models/resp-errors.model';
import LogRocket from 'logrocket';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-basic-data',
  templateUrl: './basic-data.component.html',
  styleUrls: ['./basic-data.component.css'],
})
export class BasicDataComponent implements OnInit {
  @ViewChild(FormComponent) appFormComponent!: FormComponent;

  _submitMessage = '';
  generalParameters: any = '';
  basicData!: FormGroup;
  frmStepOne$!: Observable<FormGroup>;
  regexNumbers: any = /^[0-9]*$/;
  regexWords: any = /^[a-zA-Z\s]*$/;
  regexMail: any = /^[\w\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  small = 600;
  verticalclass = true;
  pantalla: any = window.innerWidth;
  minDate: any;
  maxDate: any;
  disableButton: boolean = false;
  customerPerson!: Customer;
  clientParameter: string = '';
  controls$: Observable<ControlBase<string>[]> = EMPTY;
  appLoaderGif: string = `assets/img/LogoApprobe.gif`;

  private myFrmStepOne$ = new BehaviorSubject<FormGroup>(this.basicData);
  myFrmStepOneListener$: Observable<FormGroup> =
    this.myFrmStepOne$.asObservable();

  navigationExtras: NavigationExtras = {};

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private readonly bnplService: BnplService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.controls$ = this.bnplService.getControlsBasicData();
  }

  getInfoForm(basicData: FirstStep) {
    this.bnplService.alertWait();
    this.bnplService.stepsInformation.firstStep = basicData;

    let data = {
      actionStrategyPattern: 'SEARCH_CUPOS',
      tipoIdentificacion: environment.typeId,
      tipoIdentificacionText: environment.descriptionId,
      identificacion: basicData.numeroDocumento,
      celularFormulario: basicData.celular,
      emailFormulario: '',
    };

    LogRocket.identify(basicData.numeroDocumento, {
      name: 'BNPL Producción',
    });

    this.bnplService.validateQuotasId(data).subscribe({
      next: (resp: any) => {
        this.navigationExtras = { state: resp };
        localStorage.setItem('id', resp.id);

        if (resp.validationStrategy == 'CUPO') {
          Swal.close();
          this.router.navigate(['/personal-information']);
        }

        if (resp.validationStrategy == 'RECONOCER') {
          Swal.close();
          this.router.navigate(['/confirm-otp']);
        }

        if (resp.showMessage == 1) {
          this.appFormComponent.resetForm();
          Swal.close();
          this.bnplService.openSnack(resp);
        }

        if (resp.showMessage == 2) {
          Swal.close();
          this.router.navigate(
            ['/await-alert', 'error'],
            this.navigationExtras
          );
        }

        if (resp.errorMessage) {
          this.router.navigate(['/await-alert', 'error-connection']);
        }
      },
      error: (e: any) => {
        Swal.close();
        this.router.navigate(['/await-alert', 'error-connection']);
        console.log('error', e);
      },
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.pantalla = window.innerWidth;

    if (this.pantalla < this.small) {
      this.verticalclass = false;
    } else {
      this.verticalclass = true;
    }
  }
}
